export default __webpack_public_path__ + "static/underline-24-e3a9443e0dccdfaaf511aff2bf4253f7.svg";